import React, { Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';

import { ApiHelper } from '../../common/helpers/ApiHelper';
import { Helper } from '../../common/helpers/Helper';
import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { AppConfig } from '../../AppConfig';
import { UiHelper } from '../../common/helpers/UiHelper';
const vsprintf = require('sprintf-js').vsprintf

export class Jobs extends BaseEntityPage {

  constructor(props) {
    super(props);
    this.pageKey = 'Jobs'
    this.pageTitle = 'Jobs'
    this.noTableHead = true
    this.orgId = this.props.match.params.orgId || 'PRODUCT'
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: 'Job History' },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['jobs'], queryParams: { groupId: this.orgId, pb: 'fieldDefJob', limit: 100 } },
      { method: 'GET', paths: ['miscs', 'orgsearch'], queryParams: {
        shallow: true, state: 'LIVE', limit: AppConfig.ORG_SEARCH_LIMIT, accessOrgId: this.orgId
      } }
    ]
    this.tableHeadersMap = {
      Index: (current) => current.__index + 1,
      Job: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.action}</span>
            <br/>
            <span className={css(Styles.spanValue)}>Job started at: {Helper.formatTimestamp(current.createdTs)}</span>
            <br/>
          </div>
        )
      },
      Status: (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.state}</span>
            <br/>
            {current.state === 'SUCCESS' && current.action === 'SYNC_TO_WICHARGE' &&
              <span>
                <span className={css(Styles.spanValue)}>{current.result.updated} updated, {current.result.errors} errors</span>
                <br/>
              </span>
            }
            {current.state === 'SUCCESS' && current.action === 'SYNC_TO_HIVE' && current.result &&
              <span>
                <span className={css(Styles.spanValue)}>{current.result.updated} updated</span>
                <br/>
                {current.result.links && current.result.links.map(linkItem => {
                  return(
                    <Fragment key={'result_' + current.id + '_' + linkItem.title}>
                      <a className={css(Styles.spanValue)} href={linkItem.link}>{linkItem.title}</a>
                      <br/>
                    </Fragment>
                  )
                })}
              </span>
            }
            {current.state === 'SUCCESS' && current.action === 'UPDATE_VENUES' &&
              <span>
                <span className={css(Styles.spanValue)}>{current.result.stats.update} updated & {current.result.stats.new} skipped</span>
                <br/>
              </span>
            }
            {current.state === 'SUCCESS' && current.action === 'RUN_GOOGLE_PLACES_FOR_MODIFIED_VENUES' &&
              <span>
                <span className={css(Styles.spanValue)}>Google Places API: {current.result.updated} fetched & {current.result.error} errors</span>
                <br/>
              </span>
            }
            {current.state === 'SUCCESS' && ( current.action === 'EXPORT_VENUES' || current.action === 'EXPORT_VENUES_SELECTED' || current.action === 'EXPORT_FROM_FRAMEN' ) && current.result && current.result.stats &&
              <span>
                <span className={css(Styles.spanValue)}>Export for {current.info.format}: {current.result.stats.exported} exported, {current.result.stats.incomplete} skipped & {current.result.stats.archived} archived</span>
                <br/>
                {current.result.links && current.result.links.map(linkItem => {
                  return(
                    <Fragment key={'result_' + current.id}>
                      <a className={css(Styles.spanValue)} href={linkItem.link}>{linkItem.title}</a>
                      <br/>
                    </Fragment>
                  )
                })}
              </span>
            }
            {current.state === 'SUCCESS' && (current.action === 'VIOOH_INVENTORY') && current.result &&
              <span>
                <span className={css(Styles.spanValue)}>Download Result</span>
                <br />
                {current.result.links && current.result.links.map(linkItem => {
                  return (
                    <Fragment key={'result_' + current.id}>
                      <a className={css(Styles.spanValue)} href={linkItem.link}>{linkItem.title}</a>
                      <br />
                    </Fragment>
                  )
                })}
              </span>
            }
            {current.state === 'SUCCESS' && ( current.action === 'EXPORT_FROM_FRAMEN' ) && current.result &&
              <span>
                <span className={css(Styles.spanValue)}>Export of all venues we added in Framen</span>
                <br/>
                {current.result.links && current.result.links.map(linkItem => {
                  return(
                    <Fragment key={'result_' + current.id}>
                      <a className={css(Styles.spanValue)} href={linkItem.link}>{linkItem.title}</a>
                      <br/>
                    </Fragment>
                  )
                })}
              </span>
            }
            {current.state === 'SUCCESS' && current.action === 'EXPORT_ORGS' &&
              <span>
                <span className={css(Styles.spanValue)}>{current.result.stats.exported} exported, {current.result.stats.incomplete} skipped</span>
                <br/>
                <a className={css(Styles.spanValue)} href={current.result.link}>Download Orgs CSV</a>
                <br/>
              </span>
            }
            {current.state === 'SUCCESS' && current.action === 'VENUE_EXCHANGE_REPORT' &&
              <span>
                <a className={css(Styles.spanValue)} href={current.result.link}>Download Venue Exchange Report CSV</a>
                <br/>
              </span>
            }
            {current.state === 'SUCCESS' && current.action === 'SCREEN_FILL_RATE_REPORT' &&
              <span>
                <a className={css(Styles.spanValue)} href={current.result.link}>Download Venue Exchange Report CSV</a>
                <br/>
              </span>
            }
            {current.state === 'SUCCESS' && ( current.action === 'BULK_TASKS' ) && current.result &&
              <span>
                {current.result.stats &&
                  <Fragment>
                    <span className={css(Styles.spanValue)}>{current.result.stats.success} success, {current.result.stats.skipped} skipped, {current.result.stats.errors} errors</span>
                    <br/>
                  </Fragment>
                }
                <span className={css(Styles.spanValue)}>Download Result</span>
                <br/>
                {current.result.links && current.result.links.map(linkItem => {
                  return(
                    <Fragment key={'result_' + current.id}>
                      <a className={css(Styles.spanValue)} href={linkItem.link}>{linkItem.title}</a>
                      <br/>
                    </Fragment>
                  )
                })}
              </span>
            }
            {current.state === 'SUCCESS' && (current.action === 'CHANGE_VENUE_FIELDS' || current.action === 'BULK_SCREEN_CREATE' || current.action === 'CREATE_BRAND_NAME' || current.action === 'SCREEN_TIMESERIES_REPORT') && current.result &&
              <span>
                {current.result.stats &&
                  <Fragment>
                    <span className={css(Styles.spanValue)}>{current.result.stats.success} success, {current.result.stats.skipped} skipped, {current.result.stats.errors} errors</span>
                    <br />
                  </Fragment>
                }
                <span className={css(Styles.spanValue)}>Download Result</span>
                <br />
                {current.result.links && current.result.links.map(linkItem => {
                  return (
                    <Fragment key={'result_' + current.id}>
                      <a className={css(Styles.spanValue)} href={linkItem.link}>{linkItem.title}</a>
                      <br />
                    </Fragment>
                  )
                })}
              </span>
            }
            {current.state === 'SUCCESS' && (current.action === 'CHANGE_ORG_FIELDS') && current.result &&
              <span>
                {current.result.stats &&
                  <Fragment>
                    <span className={css(Styles.spanValue)}>{current.result.stats.success} success, {current.result.stats.skipped} skipped, {current.result.stats.errors} errors</span>
                    <br />
                  </Fragment>
                }
                <span className={css(Styles.spanValue)}>Download Result</span>
                <br />
                {current.result.links && current.result.links.map(linkItem => {
                  return (
                    <Fragment key={'result_' + current.id}>
                      <a className={css(Styles.spanValue)} href={linkItem.link}>{linkItem.title}</a>
                      <br />
                    </Fragment>
                  )
                })}
              </span>
            }
            {current.state === 'SUCCESS' && (current.action === 'CMS_REPORT') && current.result &&
              <span>
                <span className={css(Styles.spanValue)}>Download Result</span>
                <br />
                {current.result.links && current.result.links.map(linkItem => {
                  return (
                    <Fragment key={'result_' + current.id}>
                      <a className={css(Styles.spanValue)} href={linkItem.link}>{linkItem.title}</a>
                      <br />
                    </Fragment>
                  )
                })}
              </span>
            }
            {current.state === 'ERROR' &&
              <span>
                <span className={css(Styles.spanValue)}>
                  {vsprintf('%s', [current.result.payload ? current.result.payload.message : 'Unknown'])}
                </span>
                <br/>
              </span>
            }
          </div>
        )
      },
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
      groupId: this.orgId
    }
    this.headerActions = [
      {
        label: 'Refresh',
        icon: 'refresh',
        type: 'icon-mobile',
        onClick: () => this.fetchItems()
      },
      {
        label: 'New Job',
        icon: 'add',
        type: 'icon-mobile',
        onClick: () => this.openModalForAdd()
      },
    ]
  }

  _changePaginationLimit() {
    if(this.toFetchNext && this.toFetchNext.queryParams && this.toFetchNext.queryParams.limit) this.toFetchNext.queryParams.limit = 1000
  }

  onFetchSuccess(results, opts) {
    const { fetchNext } = opts || {}
    if(results[0]) this.handleNextpage(results[0])
    this._changePaginationLimit()
    if (fetchNext) {
      const updatedItems = this.state.items.concat(Helper.dictToArray(results[0].items))
      this.setState({
        items: updatedItems,
        nextPageState: ApiHelper.State.READY,
      })
      return
    }

    this.fieldDef = this.formDefinition = results[0].fieldDefJob
    this.fieldDef.ctaButtonText = 'Run'
    const fieldAction = this.formDefinition.steps[0].fields.find(i => i.key === 'action')
    fieldAction.options = fieldAction.options.filter(i => !i.key.startsWith('_'))

    const orgs = results[1] ? (results[1].items || []) : []
    const orgsByType = {
      PARTNER: [],
      SITE: [],
      FA: [],
      PA: []
    }
    orgs.forEach(org => {
      const orgType = org.groupId || 'SITE'
      if (orgsByType[orgType]) orgsByType[orgType].push(org)
    })
    UiHelper.populateOptions(this.formDefinition, { items: orgsByType.PARTNER }, 'partner')
    UiHelper.populateOptions(this.formDefinition, { items: orgsByType.SITE }, 'site')
    UiHelper.populateOptions(this.formDefinition, { items: orgsByType.FA }, 'fa')
    UiHelper.populateOptions(this.formDefinition, { items: orgsByType.PA }, 'pa')

    this.setState({
      items: results[0].items,
    })
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) { return '' }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onAdd() {
    this.setState({
      apiMethod: 'POST',
      apiEndPoint: ApiHelper.makeUrlPath(['jobs']),
    });
  }

  onActions(current) {
    const actions = []
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  }
})


// WEBPACK FOOTER //
// ./src/screens/admin/Jobs.js